import { useState, useEffect, useMemo } from "react";
import { Divider, Group, TextInput, Button, Paper, Text, Stack, Table, Select, Title, FileInput, Badge } from "@mantine/core";
import { Card, message, Flex, Spin, Alert } from "antd";
import { useAuthContext } from "../../Hooks/UseAuthContext";






const Uploaddocs = ({ rectification = false, stepData, submissionDetails, onSuccess }) => {
    const { user } = useAuthContext();
    const [companyProfile, setCompanyProfile] = useState(null);
    const [compliancedetails, setCompliancedetails] = useState(null);
    const [banksdetails, setbanksdetails] = useState(null);
    const [merchantduedeligencedetails, setmerchantduedeligencedetails] = useState(null);
    const [boardresolution, setboardresolution] = useState(null);
    const [merchantcriminalundertaking, setmerchantcriminalundertaking] = useState(null);
    //const [undertakingDate, setUndertakingDate] = useState("");
    // const [commercialDate, setCommercialDate] = useState("");
    // const [implementationCharge, setImplementationCharge] = useState("");
    // const [payoutUseCase, setPayoutUseCase] = useState("");
    //const [chargebackAcceptance, setChargebackAcceptance] = useState("Yes");
    //const [serviceAcceptance, setServiceAcceptance] = useState("Yes");
    const [selectedDocument, setSelectedDocument] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [uploadLoading, setUploadLoading] = useState(false);

    const [uploadedFiles, setUploadedFiles] = useState([]);


    // =========================
    // DYNAMIC DROPDOWN OPTIONS
    // =========================

    const uploadOptions = useMemo(() => {

        if (!merchantduedeligencedetails) return [];

        return [
            "Payment_Receipt",

            ...Object.entries(merchantduedeligencedetails)
                .filter(([key, value]) => value === "Yes")
                .map(([key]) => key)

        ];

    }, [merchantduedeligencedetails]);

    // =========================
    // ALREADY UPLOADED DOCUMENTS
    // =========================

    const uploadedDocumentNames = uploadedFiles?.map(
        item => item.document_name
    );

    // =========================
    // FILE VALIDATION
    // =========================

    const allowedFormats = [
        "application/pdf",
        "image/png",
        "image/jpeg",
        "image/jpg"
    ];

    const maxSize = 5 * 1024 * 1024;

    const handleFile = (file) => {

        if (!file) return;

        if (!allowedFormats.includes(file.type)) {
            message.error(
                "Only PDF, JPG, JPEG, PNG files allowed"
            );
            return;
        }

        if (file.size > maxSize) {
            message.error("Maximum file size is 5MB");
            return;
        }

        setSelectedFile(file);
    };

    // =========================
    // HANDLE UPLOAD
    // =========================

    const handleUpload = async () => {

        if (!selectedDocument) {
            message.error("Please select document type");
            return;
        }

        if (!selectedFile) {
            message.error("Please select file");
            return;
        }

        try {

            setUploadLoading(true);
            const formData = new FormData();
            formData.append("document_name", selectedDocument);
            formData.append("document_file",selectedFile);
            formData.append("Registered_Name_of_Company", companyProfile?.Company_name || "");
            formData.append("Registered_PAN_Number", companyProfile?.Company_PAN_number || "");
            formData.append("Registered_GST_Number", companyProfile?.Company_GST_number || "");
            formData.append("upload_date", new Date().toISOString());
            formData.append("Company_profile_schema_id", companyProfile?._id);
            formData.append("Compliance_and_MAF_schema_id", compliancedetails?._id);
            formData.append("Bank_details_schema_id", banksdetails?._id);
            formData.append("Merchant_due_deligence_schema_id", merchantduedeligencedetails?._id);
            formData.append("Board_of_resolution_schema_id", boardresolution?._id);
            formData.append("Merchant_criminal_undertaking_schema_id", merchantcriminalundertaking?._id);
            formData.append("Completed_step", 9);


            // =========================
            // BACKEND API
            // =========================

            const response = await fetch( "https://api.boompay.in/upload-documents",{
                    method: "POST",
                    headers: {
                        'Authorization': `Bearer ${user}`,
                    },
                    body: formData,
                }
            );

            const data = await response.json();

            if (response.status === 201) {
                message.success(data.message);
                setUploadedFiles(prev => [
                    ...prev,
                    data.document
                ]);

                setSelectedDocument("");
                setSelectedFile(null);

            } else {
                message.error(data.message);
            }

        } catch (error) {
            console.log(error);
            message.error("Something went wrong while uploading");
        } finally {
            setUploadLoading(false);
        }
    };

    const handleRectificationSubmit = async () => {
        if (!selectedDocument) {
            message.error("Please select document type");
            return;
        }

        if (!selectedFile) {
            message.error("Please select file");
            return;
        }
        setUploadLoading(true);
        const formData = new FormData();
        formData.append("document_name",selectedDocument);
        formData.append("document_file",selectedFile);
        formData.append("Company_profile_schema_id", companyProfile?._id);
        try {
            const response = await fetch('https://api.boompay.in/put/rectify/upload-documents', {
                method: "PUT",
                headers: {
                    'Authorization': `Bearer ${user}`,
                },
                body: formData,
            });

            const data = await response.json();
            if (response.status === 201) {
                //console.log(data.message);
                message.success(data?.message)
                onSuccess(); // Refresh user data to update.
                setUploadLoading(false);
            } else if (response.status === 400) {
                message.error(data.message);
                console.log(data.message);
            } else if (response.status === 401) {
                message.error('Unauthorized access. Please log in again.');
                console.log('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                message.error(data?.message);
                //console.log(data);
            } else {
                message.error('An error occurred while submitting company profile.');
                console.log('An error occurred while submitting company profile.');
            }
        } catch (error) {
            message.error('An error occurred while submitting company profile.');
            console.error('Error:', error);
        }
        setUploadLoading(false);
    }

    // const handelSubmit = async () => {
    //     if (!commercialDate) {
    //         message.error('Please enter the commercial date before submitting the form.');
    //         return;
    //     }
    //     if (!payoutUseCase) {
    //         message.error('Please enter the purpose/use case of payout before submitting the form.');
    //         return;
    //     }
    //     if (chargebackAcceptance !== 'Yes' && serviceAcceptance !== 'Yes') {
    //         message.error('Please accept the chargeback and service acceptance terms before submitting the form.');
    //         return;
    //     }

    //     setSubmitloading(true);
    //     try {
    //         const response = await fetch('http://localhost:8000/submit-payout-commercial-offer-letter', {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'Authorization': `Bearer ${user}`,
    //             },
    //             body: JSON.stringify({
    //                 Registered_Name_of_Company: companyProfile?.Company_name || "",
    //                 Registered_GST_Number: companyProfile?.Company_GST_number || "",
    //                 Commercial_Date: commercialDate,
    //                 One_time_Implementation_Charges: totalImplementationCharge || 0,
    //                 Selected_Services: companyProfile?.Services_opted?.map(service => {

    //                     const matchedService = Servicespricecost.find(
    //                         item => item.service_name === service
    //                     );

    //                     return {
    //                         Service_name: service,
    //                         One_time_implementation_charge:
    //                             Number(matchedService?.One_time_implementation_charge || 0)
    //                     };

    //                 }),
    //                 Authorised_Signatory: companyProfile?.Directors?.filter(d => d.Is_Authroized_signatory).map(d => ({
    //                     Authorised_name: d.Director_name,
    //                     Authorised_mobile_number: d.Director_mobile_number,
    //                     Authorised_email: d.Director_email,
    //                     Authorised_DIN_number: d.Director_DIN_number,
    //                     Authorised_Share_perecentage: d.Share_perecentage,
    //                 })) || [],
    //                 Purpose_Use_Case_of_Payout: payoutUseCase,
    //                 Chargeback_Acceptance: chargebackAcceptance,
    //                 Service_Acceptance: serviceAcceptance,
    //                 Merchant_criminal_undertaking_schema_id: merchantcriminalundertaking?._id,
    //                 Board_of_resolution_schema_id: boardresolution?._id,
    //                 Bank_details_schema_id: banksdetails?._id,
    //                 Merchant_due_deligence_schema_id: merchantduedeligencedetails?._id,
    //                 Company_profile_schema_id: companyProfile._id,
    //                 Compliance_and_MAF_schema_id: compliancedetails._id,
    //                 Completed_step: 8, // Update the Completed_step to 8 after submitting payout commercial leter
    //             }),
    //         });
    //         const data = await response.json();
    //         if (response.status === 201) {
    //             console.log(data.message);
    //             getUserData();
    //             setSubmitloading(false);
    //             message.success(data.message);
    //         } else if (response.status === 401) {
    //             console.log('Unauthorized access. Please log in again.');
    //             message.error('Unauthorized access. Please log in again.');
    //             setSubmitloading(false);
    //         } else {
    //             console.log('An error occurred while submitting bank details.');
    //             message.error('An error occurred while submitting bank details.');
    //             setSubmitloading(false);
    //         }
    //     } catch (error) {
    //         console.error('Error:', error);
    //         message.error('An unexpected error occurred. Please try again later.');
    //         setSubmitloading(false);
    //     }
    // }
    useEffect(() => {
        const getCompanyProfile = async () => {
            const response = await fetch('https://api.boompay.in/get-company-profile', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                //console.log(data.Companyprofile);
                setCompanyProfile(data.Companyprofile);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Company profile not found.');
                message.error('Company profile not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getComplianceandmaf = async () => {
            const response = await fetch('https://api.boompay.in/get-compliance-details-and-maf', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Complianceandmafdetails);
                setCompliancedetails(data.Complianceandmafdetails);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Compliance details not found.');
                message.error('Compliance details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getbanksdetails = async () => {
            const response = await fetch('https://api.boompay.in/get-bank-details', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setbanksdetails(data.Banksdetails);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Banks details not found.');
                message.error('Banks details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getmerchantduedeligence = async () => {
            const response = await fetch('https://api.boompay.in/get-merchant-due-deligence', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setmerchantduedeligencedetails(data.Merchantduedeligence);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Merchant details not found.');
                message.error('Merchant details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getboardofresolution = async () => {
            const response = await fetch('https://api.boompay.in/get-board-of-resolution', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setboardresolution(data.Boardresolution);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Merchant details not found.');
                message.error('Merchant details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getmerchantcriminalundertaking = async () => {
            const response = await fetch('https://api.boompay.in/get-merchant-criminal-undertaking', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setmerchantcriminalundertaking(data.Merchantcriminalundertaking);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Merchant details not found.');
                message.error('Merchant details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }

        if (user) {
            getCompanyProfile();
            getComplianceandmaf();
            getbanksdetails();
            getmerchantduedeligence();
            getboardofresolution();
            getmerchantcriminalundertaking();
        }
    }, [user])
    // calculate total implementation charges

    useEffect(() => {
        const getUserData = async () => {
            setUploadLoading(true);
            const response = await fetch('https://api.boompay.in/get-submitted-details-for-rectification', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            //console.log(data);

            if (response.status === 200) {
                const profile = data.RectificationDetails.Upload_documents_schema_id;
                // Bank Details
                setUploadedFiles(profile.uploaded_documents || []);
                setUploadLoading(false);
            } else if (response.status === 401) {
                setUploadLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                setUploadLoading(false);
                console.log('User not found.');
                message.error('User not found.');
            } else {
                setUploadLoading(false);
                console.log('An error occurred while fetching user data.');
                message.error('An error occurred while fetching user data.');
            }
        }

        if (user && rectification) {
            getUserData();
        }
    }, [user, rectification])
    return (
        <>
            <Flex gap="medium" vertical>
                <Spin spinning={uploadLoading} size="large" description="Please wait...">
                    <Card title="Upload documents" style={{ "box-shadow": "rgba(0, 0, 0, 0.24) 0px 3px 8px", }}>
                        <Alert type="info" title="Please upload all documents carefully for verification purposes. Ensure that every document is clear, properly scanned, and fully readable. Kindly make sure all required instructions have been followed, such as submitting documents on the company letterhead wherever applicable and including the authorized signatory’s signature, stamp, and other necessary details." showIcon />
                        <Group mt={'xs'}>
                            <TextInput label="Company name" value={companyProfile?.Company_name || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company CIN number" value={companyProfile?.Company_CIN_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company PAN number" value={companyProfile?.Company_PAN_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="GST number" value={companyProfile?.Company_GST_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="MSME number" value={companyProfile?.Company_MSME_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company address" value={companyProfile?.Company_address || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company mobile number" value={companyProfile?.Company_Mobile_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company email id" value={companyProfile?.Company_email || ""} disabled radius="xs" size="md" />
                        </Group>
                        <Divider label="Upload documents" my="sm" variant="dashed" labelPosition="center" />
                        <Paper
                            withBorder
                            shadow="xs"
                            p="xl"
                            radius="md"
                        >

                            <Stack gap="lg">
                                {/* ========================= */}
                                {/* SELECT DOCUMENT */}
                                {/* ========================= */}

                                <Select
                                    label="Select Document Type"
                                    placeholder="Choose document"
                                    value={selectedDocument}
                                    onChange={setSelectedDocument}
                                    searchable
                                    required
                                    data={uploadOptions.map(option => ({
                                        value: option,
                                        label: uploadedDocumentNames.includes(option)
                                            ? `✅ ${option}`
                                            : option,

                                        disabled: !rectification ? uploadedDocumentNames.includes(option) : ''
                                    }))}
                                />

                                {/* ========================= */}
                                {/* FILE INPUT */}
                                {/* ========================= */}

                                <FileInput
                                    label="Upload File"
                                    placeholder="Select file"
                                    value={selectedFile}
                                    onChange={handleFile}
                                    required
                                    accept=".pdf,.png,.jpg,.jpeg"
                                />

                                <Text size="xs" c="dimmed">
                                    Allowed formats: PDF, PNG, JPG, JPEG
                                    | Maximum size: 5MB
                                </Text>

                                {/* ========================= */}
                                {/* UPLOAD BUTTON */}
                                {/* ========================= */}

                                {/* <Button
                                    loading={uploadLoading}
                                    onClick={handleUpload}
                                >
                                    Upload Document
                                </Button> */}
                                <Button
                                    loading={uploadLoading}
                                    onClick={
                                        rectification
                                            ? handleRectificationSubmit
                                            : handleUpload
                                    }
                                >
                                    {
                                        rectification
                                            ? "Upload Rectification Document "
                                            : "Upload Document"
                                    }
                                </Button>

                                <Divider />

                                {/* ========================= */}
                                {/* UPLOADED FILES TABLE */}
                                {/* ========================= */}

                                <Title order={5}>
                                    Uploaded Documents
                                </Title>

                                <Table
                                    withTableBorder
                                    withColumnBorders
                                    striped
                                    highlightOnHover
                                >

                                    <Table.Thead>

                                        <Table.Tr>

                                            <Table.Th>
                                                S.No
                                            </Table.Th>

                                            <Table.Th>
                                                Document Type
                                            </Table.Th>

                                            <Table.Th>
                                                File Name
                                            </Table.Th>

                                            <Table.Th>
                                                Status
                                            </Table.Th>

                                        </Table.Tr>

                                    </Table.Thead>

                                    <Table.Tbody>

                                        {uploadedFiles.length > 0 ? (

                                            uploadedFiles?.map((file, index) => (

                                                <Table.Tr key={index}>

                                                    <Table.Td>
                                                        {index + 1}
                                                    </Table.Td>

                                                    <Table.Td>
                                                        {file.document_name}
                                                    </Table.Td>

                                                    <Table.Td>
                                                        {file.original_file_name}
                                                    </Table.Td>

                                                    <Table.Td>

                                                        <Badge color="green">
                                                            Uploaded
                                                        </Badge>

                                                    </Table.Td>

                                                </Table.Tr>

                                            ))

                                        ) : (

                                            <Table.Tr>

                                                <Table.Td
                                                    colSpan={4}
                                                    style={{
                                                        textAlign: "center"
                                                    }}
                                                >

                                                    No documents uploaded

                                                </Table.Td>

                                            </Table.Tr>

                                        )}

                                    </Table.Tbody>

                                </Table>

                            </Stack>

                        </Paper>



                        {/* <Group justify="end">
                            <Button mt={'md'} size="lg" color="teal" variant="light" onClick={handlePrint}>Print Payout Commercial Offer Letter </Button> 
                            <Button mt={'md'} size="lg" color="lime" variant="light" onClick={handleUpload} loading={submitloading}>Save changes</Button>
                        </Group> */}

                    </Card>
                </Spin>
            </Flex>

        </>
    )
}
export default Uploaddocs